import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { HL7 } from '../../constant';

export interface GetDistributionCountsPayload {
  studyInstanceUIDs: string[];
}

export interface DistributionEntry {
  status: string;
  toProviderName?: string;
  createdAt?: string;
}

export interface DistributionInfo {
  count: number;
  distributions: DistributionEntry[];
}

export const getDistributionCountsApi = createAsyncThunk(
  'hl7/getDistributionCounts',
  async (payload: GetDistributionCountsPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      if (!token) {
        return rejectWithValue('No token found');
      }
      const { studyInstanceUIDs } = payload;
      if (!studyInstanceUIDs?.length) {
        return rejectWithValue('No studyInstanceUIDs provided');
      }
      const url = `${HL7.DISTRIBUTION_COUNTS}?studyInstanceUIDs=${encodeURIComponent(
        studyInstanceUIDs.join(',')
      )}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const result = await response.json();
      if (!response.ok) {
        return rejectWithValue(result.msg || `Distribution counts failed: ${response.status}`);
      }
      return (result.result || {}) as Record<string, DistributionInfo>;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
